import React from 'react'
import { Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import { useResourceSidebarContext } from '../hooks/useResourceSidebarContext'
import { SIDEBAR_WIDTH, SidebarPanel } from './sidebar/sidebarPrimitives'
import GlobalSidebar from './sidebar/GlobalSidebar'
import ResourceContextSidebar from './sidebar/ResourceContextSidebar'

const Sidebar: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const context = useResourceSidebarContext()

  if (!isAuthenticated) return null

  return (
    <Box
      data-testid="sidebar"
      sx={{
        display: { xs: 'none', md: 'block' },
        flexShrink: 0,
        alignSelf: 'stretch',
        position: 'relative',
        width: SIDEBAR_WIDTH,
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <SidebarPanel visible={!context.isContextMode} data-testid="global-sidebar-panel">
        <GlobalSidebar />
      </SidebarPanel>
      <SidebarPanel visible={context.isContextMode} data-testid="context-sidebar-panel">
        {context.mode !== 'global' ? (
          <ResourceContextSidebar context={context} />
        ) : null}
      </SidebarPanel>
    </Box>
  )
}

export default Sidebar
